var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreyDollarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 18,
    viewBox: "0 0 11 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.32124 0.88623V2.95399H2.77042C1.36434 2.95399 0.185717 4.13261 0.185717 5.53869V6.57257C0.185717 7.97865 1.09553 9.13659 2.43957 9.48811L7.73304 10.8528C8.02253 10.9355 8.43608 11.4525 8.43608 11.7626V12.7965C8.43608 13.086 8.20862 13.3135 7.91914 13.3135H2.74974C2.57014 13.3128 2.39316 13.2703 2.2328 13.1894V11.2457H0.165039V13.3135C0.165039 14.0165 0.578591 14.6162 1.07485 14.9263C1.55044 15.2572 2.15009 15.3812 2.74974 15.3812H4.30056V17.449H6.36832V15.3812H7.91914C9.34589 15.3812 10.5038 14.2233 10.5038 12.7965V11.7626C10.5038 10.3566 9.59402 9.19863 8.24998 8.84711L2.95651 7.48239C2.66703 7.39968 2.25348 6.88274 2.25348 6.57257V5.53869C2.25348 5.2492 2.48093 5.02175 2.77042 5.02175H7.93982C8.16727 5.02175 8.37405 5.10446 8.45676 5.14582V7.08951H10.5245V5.02175C10.5245 4.31871 10.111 3.71906 9.6147 3.4089C9.13912 3.07806 8.53947 2.95399 7.93982 2.95399H6.389V0.88623H4.32124Z",
    fill: "#686868"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyDollarIcon);
export default __webpack_public_path__ + "static/media/grey_dollar_icon.edc70278c01d56494db67470ca75c0cc.svg";
export { ForwardRef as ReactComponent };